import { render, staticRenderFns } from "./lssy.vue?vue&type=template&id=0a61cd4c&scoped=true"
import script from "./lssy.vue?vue&type=script&lang=js"
export * from "./lssy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a61cd4c",
  null
  
)

export default component.exports